<input id="{{ctrl.type}}"
       name="{{ctrl.name}}"
       type="password"
       ng-required="ctrl.validation.config.required"
       ng-minlength="ctrl.validation.config.minlength"
       ng-maxlength="ctrl.validation.config.maxlength"
       ng-pattern="ctrl.validation.config.pattern"
       ng-model="ctrl.password1"
       placeholder="{{ctrl.placeHolder1}}"/>
<div class="error-text" ng-show="ctrl.validation.errorFnc()">{{ctrl.validation.errorText() | translate}}</div>
<input
    type="password"
    ng-model="ctrl.password2"
    ng-class="{'match': ctrl.classMatch(), 'no-match': ctrl.classNoMatch()}"
    placeholder="{{ctrl.placeHolder2}}"/>
<div class="no-match-text" ng-show="ctrl.classNoMatch()">{{'passwordPicker.passwordNoMatch'|translate}}</div>
<div class="force">{{'passwordPicker.strength'|translate}} {{ctrl.force}}%</div>
<ul id="force">
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
    <li class="point"></li>
</ul>

